import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppStack from './routes/AppStack';

import SidebarProvider from './context/sidebar';
import ServiceProvider from './context/services';
import RequestsProvider from './context/requests';
import ProductsProvider from './context/products';
import CategorysProvider from './context/categorys';
import MarksProvider from './context/mark';
import CartsProvider from './context/cart';
import DashboardProvider from './context/dashboard';
import ClientsProvider from './context/clients';
import PagesProvider from './context/pages';
import PostsProvider from './context/posts';
import FilterSallesProvider from './context/filterSalles';
import MarketingProvider from './context/marketing';
import SalleProvider from './context/salle';
import MercadoLivreProvider from './context/mercadoLivre';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <MercadoLivreProvider>
    <SalleProvider>
    <MarketingProvider>
    <FilterSallesProvider>
    <PostsProvider>
    <PagesProvider>
    <ClientsProvider>
    <DashboardProvider>
    <CartsProvider>
    <MarksProvider>
    <RequestsProvider>
    <CategorysProvider>
    <ProductsProvider>
    <ServiceProvider>
    <SidebarProvider>
    <AppStack />
    </SidebarProvider>
    </ServiceProvider>
    </ProductsProvider>
    </CategorysProvider>
    </RequestsProvider>
    </MarksProvider>
    </CartsProvider>
    </DashboardProvider>
    </ClientsProvider>
    </PagesProvider>
    </PostsProvider>
    </FilterSallesProvider>
    </MarketingProvider>
    </SalleProvider>
    </MercadoLivreProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
